<!-- eslint-disable -->
<template lang="pug">
    .rating-banner
        .rating-banner__header
            .header__item {{ $i18n.t('dashboard.dashboard_rating_header') }}
            .header__item.header__item--date
                month-picker(v-model="date")
        divider.rating-banner__divider(:margin="'0 auto'")
        .rating-banner__body(v-if="!isLoading")
            .rating-banner__course
                | {{ $i18n.t('common.common_course_' + selectedCourse) }}
            .rating-banner__places(v-if="!isLoading && ratings[selectedCourse] && Object.values(ratings[selectedCourse]).length")
                .rating-banner__place
                    svg-icon.rating-banner__icon.rating-banner__world(name="geolocalization" size="xx-large")
                    div {{ $i18n.t('dashboard.dashboard_rating_world') }}
                    .rating-banner__position
                        i.fa.fa-trophy(v-if="ratings[selectedCourse].system < 4", :class="getColor(ratings[selectedCourse].system)")
                        | {{ getPositionFor('system') }}
                .rating-banner__place
                    svg-icon.rating-banner__icon.rating-banner__school(name="admission" size="xx-large")
                    div {{ $i18n.t('dashboard.dashboard_rating_school') }}
                    .rating-banner__position
                        i.fa.fa-trophy(v-if="ratings[selectedCourse].school < 4", :class="getColor(ratings[selectedCourse].school)")
                        | {{ getPositionFor('school') }}
                .rating-banner__place
                    svg-icon.rating-banner__icon.rating-banner__grade(name="reward" size="xx-large")
                    div {{ $i18n.t('dashboard.dashboard_rating_grade') }}
                    .rating-banner__position
                        i.fa.fa-trophy(v-if="ratings[selectedCourse].grade < 4", :class="getColor(ratings[selectedCourse].grade)")
                        | {{ getPositionFor('grade') }}
            .rating-banner__empty(v-else)
                | {{ phrase }}
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import moment from "moment"
    import MonthPicker from '../../../elements/MonthPicker.vue'
    import RatingApi from '../../../api/rating.js'
    import { mapState } from 'vuex';

    export default {
        components: {
            MonthPicker
        },
        data () {
            return {
                phrase: this.$i18n.t('dashboard.dashboard_rating_noPoints'),
                date: null,
                ratings: [],
                isLoading: false
            }
        },
        mounted () {
            this.date = moment().format('YYYY-MM-DD');
        },
        watch: {
            date (value) {
                if (moment(value).diff(moment(), 'months') < 0) {
                    this.phrase = this.$i18n.t('dashboard.dashboard_rating_noPointsPrevious');
                } else {
                    this.phrase = this.$i18n.t('dashboard.dashboard_rating_noPoints');
                }
                this.getRating();
            }
        },
        methods: {
            getColor (place) {
                return {
                    gold: place === 1,
                    silver: place === 2,
                    copper: place === 3
                };
            },
            getRating () {
                this.isLoading = true;
                RatingApi.show(this.date)
                .then(ratings => {
                    this.user.pointsAccesses.forEach(access => {
                        this.ratings[access] = [];
                        if (ratings.some(rating => rating.for === access)) {
                            this.ratings[access] = ratings
                            .filter(rating => rating.for === access)
                            .reduce((places, rating) => {
                                if (
                                        (places[rating.type] && places[rating.type] < rating.position)
                                        || (!places[rating.type] || places[rating.type] === 0)
                                ) {
                                    places[rating.type] = rating.position;
                                }
                                return places;
                            }, {});
                        }
                    });
                    this.isLoading = false;
                })
                .catch(() => {
                    this.ratings = {};
                    this.isLoading = false;
                })
            },
            getPositionFor (selector) {
                let rating = this.ratings[this.selectedCourse];
                return rating[selector] <= 500 ? rating[selector] : '500+';
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            }),
        },
    }
</script>

<style lang="scss" scoped>
    $gold: #FFAD1F;
    $silver: #858585;
    $copper: #A44020;

    .gold {
        color: $gold;
    }
    .silver {
        color: $silver;
    }
    .copper {
        color: $copper;
    }

    .rating-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .rating-banner__header {
        margin: 30px 0 25px 30px;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .rating-banner__body {
        margin: 20px 30px 25px 30px;
        font-size: 16px;
        line-height: 24px;
    }

    .rating-banner__course {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;

        margin-bottom: 25px;
    }

    .rating-banner__divider {
        width: calc(100% - 60px) !important;
    }

    .rating-banner__empty {
        font-size: 16px;
        line-height: 19px;
    }

    .rating-banner__empty-icon {
        color: $hsl-color-gray-74;
        font-size: 30px;
        padding-bottom: 10px;
    }

    .header__item--date {
        padding-top: 25px;
        padding-right: 50px;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
    }

    .rating-banner__places {
        display: flex;
        justify-content: space-between;
    }

    .rating-banner__place {
        display: flex;
        flex-direction: column;
        align-items: center;

        font-size: 16px;
        line-height: 19px;
    }

    .rating-banner__position {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $hsl-color-green-58;

        margin-top: 10px;

        i {
            margin-right: 5px;
        }
    }

    .rating-banner__icon {
        margin-bottom: 10px;
    }

    .rating-banner__world {
        color: $hsl-color-yellow-66;
    }

    .rating-banner__school {
        color: $x-color-orange;
    }

    .rating-banner__grade {
        color: $hsl-color-blue-56;
    }

</style>
